import { useContext, useEffect, useState } from "react";
import { InvoiceTotalsInfo } from "../../../generated/data-contracts";
import { IAxiosError, api } from "../../../utils";
import { AvisForm } from "../../shared/components";
import { AvisDescriptiveText } from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { InvoiceAmountToPay } from "./components/InvoiceAmountToPay";
import { InvoicesGrid } from "./components/InvoicesGrid";

export function InvoicesPage() {
  const { res } = useContext(AvisContext);
  const [error, setError] = useState<IAxiosError>();
  const [loadingAmountToPay, setLoadingAmountToPay] = useState<boolean>(true);
  const [amountTotalToPay, setAmountTotalToPay] = useState<InvoiceTotalsInfo>();

  useEffect(() => {
    setLoadingAmountToPay(true);
    api
      .licenseesGetTotalPaymentOwed()
      .then((res) => setAmountTotalToPay(res.data))
      .catch(setError)
      .finally(() => setLoadingAmountToPay(false));
  }, []);

  return (
    <AvisForm
      title={res("licensees_Invoices_PageTitle_actual")}
      error={error}
      loading={loadingAmountToPay}
    >
      <AvisDescriptiveText textKey="portal_LIC_UnpaidInvoices" />
      <InvoiceAmountToPay amountTotalToPay={amountTotalToPay} />
      <InvoicesGrid setError={setError} />
    </AvisForm>
  );
}
